module.exports = __webpack_public_path__ + "static/media/card-blog2.15d3b957.jpg";